import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './component/Navigation';
import Footer from './component/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import ImageCarousel from './component/ImageCarousel';
import Projects from './pages/Projects';
import BoardOfDirectors from './pages/BoardOfDirectors';
import OurPresidents from './pages/OurPresidents'
import Publication from './pages/Publication';
import PubV3 from './pages/PubV3';
import HeroBanner from './component/HeroBanner';
import ProjectDetail from './component/ProjectDetail';
import NotFound from './pages/PageNotFound';
import "@fontsource/lato";
import "@fontsource/montserrat";
import "@fontsource-variable/fredoka";
import ScrollToTop from './helper/ScrollToTop';
import MessengerButton from './component/MessengerButton';

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // We target the class that is actually holding the scrollbar
    const container = document.querySelector('.app-container');
    
    if (container) {
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
  }, [location.pathname]);

  if (typeof window !== "undefined" && window.history.scrollRestoration) {
    window.history.scrollRestoration = 'manual';
  }

  return (
    <div className="app-container">
      <Navigation />
      {isHomePage && <ImageCarousel />}
      {!isHomePage && <HeroBanner />}
      {/* use location in react-router-dom */}
      {/* might remove banners for board of directors and past presidents */}
      <main className="main-content">
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/board-of-directors" element={<BoardOfDirectors />} />
            <Route path="/our-publication" element={< PubV3 />}></Route>
            {/* <Route path="/our-presidents" element={<OurPresidents />} /> */}
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:division/:id" element={<ProjectDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <MessengerButton />
      </main>
      <Footer />
    </div>
  );
}

export default App;